import clock from '../../../assets/clock.svg';
const Modal = ({
  statusImage = false,
  paymentStatusImage,
  title,
  body,
  hasButton = true,
  buttonText1,
  buttonText2,
  buttonClick1,
  buttonClick2,
  onClose,
  showTimer = false,
  openSupport,
  needHelp = false,
}) => {
  return (
    <div
      className="payment-modal-container"
      role="button"
      tabIndex={0}
      onClick={() => {
        if (onClose) onClose();
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          if (onClose) onClose();
        }
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        className="padding-32 col flex-center-align text-center-align payment-modal"
      >
        {statusImage && (
          <div>
            <img src={paymentStatusImage} alt="payment status" />
          </div>
        )}
        <div className="title-5 strong text-primary">{title}</div>
        <div className="body-1 regular text-grey-500">{body}</div>
        {hasButton && (
          <div
            className="row justify-center "
            style={{ gap: '12px', width: '100%' }}
          >
            {buttonText1 && (
              <button
                onClick={buttonClick1}
                className="secondary-btn-regular body-1 support-btns"
              >
                {buttonText1}
              </button>
            )}
            <button
              onClick={buttonClick2}
              className="primary-btn-large body-1 support-btns"
            >
              {buttonText2}
            </button>
          </div>
        )}
        {showTimer && (
          <>
            <div className="row flex-center-align justify-center">
              <img
                className="margin-right-4"
                src={clock}
                alt="It may take upto 10 minutes"
              />

              <div className="text-grey-500">00:00</div>
            </div>
          </>
        )}
        {needHelp && (
          <button className="text-slate-700 icon-btn" onClick={openSupport}>
            Need Help? Contact Support
          </button>
        )}
      </div>{' '}
    </div>
  );
};
export default Modal;
